/**
 * 添加拦截器:
 *   拦截 request 请求
 *   拦截 uploadFile 文件上传
 *
 * TODO:
 *   1. 非 http 开头需拼接地址
 *   2. 请求超时
 *   3. 添加小程序端请求头标识
 *   4. 添加 token 请求头标识
 */

import {getApiUrl} from "@/utils/config";
import {useAuthStore, useMemberStore} from '@/stores/modules/member'
import {isWeChat} from "@/utils/browser";
import {authorizeWxCode} from "@/utils/Wechart";
import {tokenError} from "@/utils/loginUtil";
// 添加拦截器
const httpInterceptor = {
    // 拦截前触发
    invoke(options: UniApp.RequestOptions) {
        // 1. 非 http 开头需拼接地址
        if (!options.url.startsWith('http')) {
            options.url = getApiUrl() + options.url
        }
        // 2. 请求超时, 默认 60s
        options.timeout = 10000
        // 3. 添加小程序端请求头标识
        options.header = {
            ...options.header
        }
        // 4. 添加 token 请求头标识
        const token = useAuthStore().token
        if (token) {
            options.header.token = token
        }
        // 5. 支持表单提交选择
        if (options.method === 'POST' && options.data && typeof options.data === 'object') {
            const contentType = options.header['Content-Type'] || '';
            if (contentType.includes('application/x-www-form-urlencoded')) {
                const formData = [];
                for (const key in options.data) {
                    if (options.data.hasOwnProperty(key)) {
                        formData.push(encodeURIComponent(key) + '=' + encodeURIComponent(options.data[key as keyof typeof options.data]));
                    }
                }
                options.data = formData.join('&');
                console.log(options.data);
            }
        }

    },
}


/**
 * 请求函数
 * @param  UniApp.RequestOptions
 * @returns Promise
 *  1. 返回 Promise 对象
 *  2. 获取数据成功
 *    2.1 提取核心数据 res.data
 *    2.2 添加类型，支持泛型
 *  3. 获取数据失败
 *    3.1 401错误  -> 清理用户信息，跳转到登录页
 *    3.2 其他错误 -> 根据后端错误信息轻提示
 *    3.3 网络错误 -> 提示用户换网络
 */
type Data<T> = {
    code: number
    message: string
    data: T
}



let loaded = false

// 2.2 添加类型，支持泛型
export const http = <T>(options: UniApp.RequestOptions) => {
    if(!loaded){
        loaded = true
        uni.addInterceptor('request', httpInterceptor)
        uni.addInterceptor('uploadFile', httpInterceptor)
    }

    // 1. 返回 Promise 对象
    return new Promise<Data<T>>((resolve, reject) => {
        uni.request({
            ...options,
            // 响应成功
            success(res) {
                const result = res.data as Data<T>
                if (result.code === 0 || result.code === 1010) {
                    // 2.1 提取核心数据 res.data
                    resolve(res.data as Data<T>)
                } else if (result.code === 1001) {
                    // 401错误  -> 清理用户信息，跳转到登录页
                    useAuthStore().clearToken()

                    tokenError()
                    reject(res)

                    // useAuthStore().login()
                    // uni.navigateTo({ url: '/pages/login/login' })
                    // reject(res)
                    // 登录失败的特殊处理
                } else if (options.url.includes('/sendCode') || options.url.includes('/login/mobile')) {
                    // 登录失败
                    resolve(res.data as Data<T>)
                } else {
                    // 其他错误 -> 根据后端错误信息轻提示
                    uni.showToast({
                        icon: 'none',
                        title: (res.data as Data<T>).message || '请求错误',
                    })
                    reject(res)
                    // resolve(res.data as Data<T>)
                }
            },
            // 响应失败
            fail(err) {
                uni.showToast({
                    icon: 'none',
                    title: '网络错误，换个网络试试',
                })
                reject(err)
            },
        })
    })
}
